import screen from './List';

export default screen;



// WEBPACK FOOTER //
// ./src/screens/admin/MessagesCampaigns/List/index.js